<template>
  <CContainer class="d-flex align-items-center min-vh-100 justify-content-center">
    <CRow class="justify-content-center">
      <CCol md="12">
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm>
                <h1>Вход</h1>
                <CInput
                  placeholder="Номер заказа"
                  v-model="order"
                >
                  <template #prepend-content><CIcon name="cil-notes"/></template>
                </CInput>
                <CInput
                  placeholder="Пинкод"
                  type="password"
                  autocomplete="curent-password"
                  v-model="pincode"
                  @keyup.enter="tryToLogin"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6">
                    <CButton color="primary arbat-primary-color" class="px-4" @click="tryToLogin()">
                      <span v-if="!isLoading">Войти</span>
                      <span v-if="isLoading" class="login-button-internal-margin">Проверка</span>
                      <span
                              v-if="isLoading"
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true">
                      </span>
                    </CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
            color="primary arbat-primary-color"
            text-color="white"
            class="text-center py-5 d-md-down-none"
            style="width:44%"
            body-wrapper
          >
            <h2>Фотостудия «Арбат»</h2>
            <p>Система просмотра заказов</p>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<style>
  .login-button-internal-margin {
    margin-right: 5px;
  }
  .arbat-primary-color {
    background-color: #E01023 !important;
  }
</style>

<script>
    import $ from 'jquery';
    import 'bootstrap';
    import bootbox from 'bootbox';

    export default {
        name: 'Login',
        data: () => ({
            order: '',
            pincode: '',
            isLoading: false,
        }),
        methods: {
            async tryToLogin() {
                if (this.isLoading || !this.preValidations()) {
                    return;
                }
                this.isLoading = true;
                const loginResult = await this.$authService.tryToLogin(this.order, this.pincode);
                this.isLoading = false;
                if (!loginResult) {
                    bootbox.alert({
                        title: 'Ошибка',
                        message: 'Не корректный номер заказа или пинкод',
                    });
                    return false;
                }
                this.$router.push('/');
            },
            preValidations() {
                if (this.order.length <= 0) {
                    bootbox.alert({
                        title: 'Ошибка',
                        message: 'Номер заказа не может быть пустым',
                    });
                    return false;
                }
                if (this.pincode.length !== 4) {
                    bootbox.alert({
                        title: 'Ошибка',
                        message: 'Пинкод должен содержать строго 4 последние цифры номера телефона',
                    });
                    return false;
                }
                return true;
            },
            isAuthorized() {

            }
        },
    };
</script>
